import { App } from 'vue'
import setupComponent from './setupComponent'
import setupStore from '@/modules/address-validation/setupStore'
export const init = (_app: App<Element>): void => {
  setupComponent(_app)
  setupStore()
}
